import { useEffect } from "react";

const DEFAULT_FAVICON = "/favicon.png";

export const useFavicon = (iconLink: string) => {
  useEffect(() => {
    const favicon: HTMLLinkElement | null =
      document.querySelector("link[rel~=icon]");

    if (favicon) {
      favicon.href = iconLink;
    }

    return () => {
      if (favicon) {
        favicon.href = DEFAULT_FAVICON;
      }
    };
  }, [iconLink]);
};
